import { Box } from '@mantine/core'
import { useUserRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { useStats } from '@ospace/home/hooks'
import { FullPageLayout } from '@ospace/layout'
import { ErrorBoundary } from '@ospace/shared'
import { useUser } from '@ospace/user'
import { useNavigate } from 'react-router-dom'

import { ClientsList } from '../components/ClientsList'
import { StatsList } from '../components/StatList'

export const ClientsPage = ({ user, role }: { user: any; role: userTypes }) => {
  const isDashboardUser =
    role === userTypes.Admin ||
    role === userTypes.ClientManager ||
    role === userTypes.InternalViewer
  const stats = useStats(isDashboardUser)

  if (user.status === 'success' && (!isDashboardUser || stats.status === 'success')) {
    return (
      <FullPageLayout status='ready' user={user.data} role={role} title='All Clients'>
        <Box aria-label='clients-page'>
          {stats.data && <StatsList stats={stats.data} />}
          <ClientsList role={role} title='All Clients' />
        </Box>
      </FullPageLayout>
    )
  }
  if (user.status === 'error' || stats.status === 'error') {
    return (
      <FullPageLayout
        status='error'
        user={user.data}
        role={role}
        title='All Clients'
        message='Error'
      />
    )
  }
  return <FullPageLayout status='loading' user={user.data} role={role} title='All Clients' />
}

const Controller = () => {
  const user = useUser()
  const role = useUserRole()
  const navigate = useNavigate()

  //hide this page for campaign users
  if (role === userTypes.CampaignUser) {
    navigate('/')
    return null
  }

  return <ClientsPage user={user} role={role} />
}

export const ClientsPageHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)

export default ClientsPageHandler
